$(() => {
  $('#serverRestart').on('click', () => {
    $.post($.api.common.serverRestart, {}, () => {
      alert('重启服务操作成功');
    });
  });
});
